import React from 'react';

export const TextOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-heading1"
  >
    <path d="M4 12h8"></path>
    <path d="M4 18V6"></path>
    <path d="M12 18V6"></path>
    <path d="m17 12 3-2v8"></path>
  </svg>
));

export const Heading1Outlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-heading2"
  >
    <path d="M4 12h8"></path>
    <path d="M4 18V6"></path>
    <path d="M12 18V6"></path>
    <path d="M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1"></path>
  </svg>
));

export const Heading2Outlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-heading2"
  >
    <path d="M4 12h8"></path>
    <path d="M4 18V6"></path>
    <path d="M12 18V6"></path>
    <path d="M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1"></path>
  </svg>
));

export const Heading3Outlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-heading3"
  >
    <path d="M4 12h8"></path>
    <path d="M4 18V6"></path>
    <path d="M12 18V6"></path>
    <path d="M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2"></path>
    <path d="M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2"></path>
  </svg>
));

export const BulletListOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-list"
  >
    <path d="M3 12h.01"></path>
    <path d="M3 18h.01"></path>
    <path d="M3 6h.01"></path>
    <path d="M8 12h13"></path>
    <path d="M8 18h13"></path>
    <path d="M8 6h13"></path>
  </svg>
));

export const OrderedListOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-list-ordered"
  >
    <path d="M10 12h11"></path>
    <path d="M10 18h11"></path>
    <path d="M10 6h11"></path>
    <path d="M4 10h2"></path>
    <path d="M4 6h1v4"></path>
    <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>
  </svg>
));

export const TaskListOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-list-todo"
  >
    <rect x="3" y="5" width="6" height="6" rx="1"></rect>
    <path d="m3 17 2 2 4-4"></path>
    <path d="M13 6h8"></path>
    <path d="M13 12h8"></path>
    <path d="M13 18h8"></path>
  </svg>
));

export const BlockquoteOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-quote"
  >
    <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"></path>
    <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"></path>
  </svg>
));

export const CodeBlockOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-square-code"
  >
    <path d="M10 9.5 8 12l2 2.5"></path>
    <path d="m14 9.5 2 2.5-2 2.5"></path>
    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
  </svg>
));

export const TableOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-table"
  >
    <path d="M12 3v18"></path>
    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
    <path d="M3 9h18"></path>
    <path d="M3 15h18"></path>
  </svg>
));

export const ImageOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-image"
  >
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
    <circle cx="9" cy="9" r="2"></circle>
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
  </svg>
));

export const HorizontalRuleOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-minus"
  >
    <path d="M5 12h14"></path>
  </svg>
));

export const VideoOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-video"
  >
    <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
    <rect x="2" y="6" width="14" height="12" rx="2" />
  </svg>
));

export const DateOutlined = React.memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-calendar"
  >
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
  </svg>
));

export const InfoOutlined = React.memo(() => (
  <svg focusable="false" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fill-rule="evenodd">
      <path fill="#161A1D" d="M0 0h40v40H0z"></path>
      <rect fill="var(--ds-background-accent-blue-subtlest, #E9F2FF)" x="8" y="12" width="32" height="16" rx="1"></rect>
      <path d="M12 20a4 4 0 108 0 4 4 0 00-8 0z" fill="var(--ds-icon-information, #1D7AFC)" fillRule="nonzero"></path>
      <rect fill="#09326C" fillRule="nonzero" x="15.556" y="19.722" width="1" height="2.2" rx="0.5"></rect>
      <circle fill="#09326C" fillRule="nonzero" cx="16" cy="18.444" r="1"></circle>
    </g>
  </svg>
));

export const WarningOutlined = React.memo(() => (
  <svg focusable="false" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <path fill="#161A1D" d="M0 0h40v40H0z"></path>
      <rect
        fill="var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
        x="8"
        y="12"
        width="32"
        height="16"
        rx="1"
      ></rect>
      <path
        d="M16.847 16.83l2.808 5.73a1 1 0 01-.898 1.44h-6.514a1 1 0 01-.898-1.44l2.808-5.73a1.5 1.5 0 012.694 0zm-1.347.46a.568.568 0 00-.564.635l.278 2.32a.288.288 0 00.572 0l.278-2.32a.568.568 0 00-.564-.635zm0 5.035c.318 0 .576-.293.576-.656 0-.362-.258-.656-.576-.656-.318 0-.576.294-.576.656 0 .363.258.656.576.656z"
        fill="var(--ds-icon-warning, #E56910)"
      ></path>
    </g>
  </svg>
));

export const SuccessOutlined = React.memo(() => (
  <svg focusable="false" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <path fill="#161A1D" d="M0 0h40v40H0z"></path>
      <rect
        fill="var(--ds-background-accent-green-subtlest, #DCFFF1)"
        x="8"
        y="12"
        width="32"
        height="16"
        rx="1"
      ></rect>
      <path
        d="M15 24a4 4 0 110-8 4 4 0 010 8zm.682-5.482l-1.076 2.055-.772-.695a.5.5 0 00-.668.744l1.25 1.125a.5.5 0 00.777-.14l1.375-2.625a.5.5 0 00-.886-.464z"
        fill="var(--ds-icon-success, #22A06B)"
      ></path>
    </g>
  </svg>
));

export const DangerOutlined = React.memo(() => (
  <svg focusable="false" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <path fill="#161A1D" d="M0 0h40v40H0z"></path>
      <rect fill="var(--ds-background-accent-red-subtlest, #FFECEB)" x="8" y="12" width="32" height="16" rx="1"></rect>
      <path
        d="M16.743 19.964l1.06-1.06a.5.5 0 00-.707-.707l-1.06 1.06-1.061-1.06a.5.5 0 00-.707.707l1.06 1.06-1.06 1.061a.5.5 0 10.707.707l1.06-1.06 1.061 1.06a.5.5 0 10.707-.707l-1.06-1.06zM16 24a4 4 0 110-8 4 4 0 010 8z"
        fill="var(--ds-icon-danger, #C9372C)"
      ></path>
    </g>
  </svg>
));

export const ToggleCardOutlined = React.memo(() => (
  <svg focusable="false" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fill-rule="evenodd">
      <path fill="#FFF" d="M0 0h40v40H0z"></path>
      <g transform="translate(7 8)">
        <path d="M1 0h31v24H1a1 1 0 01-1-1V1a1 1 0 011-1z" fill="#EBECF0"></path>
        <path d="M1 7h31v15H3a1 1 0 01-1-1V8a1 1 0 011-1z" fill="#FFF"></path>
        <path
          d="M5.5 18h14a.5.5 0 110 1h-14a.5.5 0 110-1zm0-3h23a.5.5 0 110 1h-23a.5.5 0 110-1zm0-3h23a.5.5 0 110 1h-23a.5.5 0 110-1zm0-3h23a.5.5 0 110 1h-23a.5.5 0 010-1z"
          fill="#A5ADBA"
        ></path>
        <rect fill="#2684FF" x="7" y="3" width="18" height="1" rx="0.5"></rect>
        <path
          d="M2.646 2.354a.5.5 0 11.708-.708l1.5 1.5a.5.5 0 010 .708l-1.5 1.5a.5.5 0 11-.708-.708L3.793 3.5 2.646 2.354z"
          fill="#2684FF"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
));
